"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseOrderInvoicedStatusEnum = void 0;
var PurchaseOrderInvoicedStatusEnum;
(function (PurchaseOrderInvoicedStatusEnum) {
    PurchaseOrderInvoicedStatusEnum["FULLY_INVOICED"] = "fullyInvoiced";
    PurchaseOrderInvoicedStatusEnum["PARTIALLY_INVOICED"] = "partiallyInvoiced";
    PurchaseOrderInvoicedStatusEnum["NOT_INVOICED"] = "notInvoiced";
})(PurchaseOrderInvoicedStatusEnum || (exports.PurchaseOrderInvoicedStatusEnum = PurchaseOrderInvoicedStatusEnum = {}));
